import * as joint from '@joint/core'

/**
 * C4 Circle shape - circular shape
 */
export const C4Circle = joint.dia.Element.define(
  'c4.Circle',
  {
    size: { width: 180, height: 180 },
    attrs: {
      body: {
        refCx: '50%',
        refCy: '50%',
        refR: '50%',
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      nameLabel: {
        refX: '50%',
        refY: '35%',
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: '50%',
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Circle]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: '65%',
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 10,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '65%',
          height: 40,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      { tagName: 'circle', selector: 'body' },
      { tagName: 'text', selector: 'nameLabel' },
      { tagName: 'text', selector: 'typeLabel' },
      { tagName: 'text', selector: 'descriptionLabel' },
    ],
  }
)

export function createCircle(
  id: string,
  name: string,
  technology: string = '',
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const typeText = technology ? `[${technology}]` : '[Circle]'

  const circle = new C4Circle({
    id,
    position: { x, y },
    attrs: {
      body: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: typeText,
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return circle
}
